import { useCapability } from '../../../../hooks/use-capability';
import { Cap } from '../../capability-matrix';
import { useDismissPattern, useSlaPatterns } from '../../hooks/use-sla';

import { adaptPattern } from './tela5-adapter';

import type { SupervisorVariant } from '../../view-models';
import type React from 'react';

/**
 * T5-2 padrões temporais detectados (Pro+) — banner real por padrão ativo +
 * Dispensar (PATCH dismiss). Gating em 2 camadas:
 *   - tier visual via <Cap variant> (sup.tela5.sla = PRO)
 *   - runtime via useCapability('sla-pattern-detection') (cap de backend Pro+)
 * Sem cap runtime ou sem padrões → não renderiza nada.
 */
export function SlaPatternsBanner({
  slaDefinitionId,
  variant,
}: {
  slaDefinitionId: string | undefined;
  variant: SupervisorVariant;
}): React.JSX.Element | null {
  const hasPatternCap = useCapability('sla-pattern-detection');
  const { data } = useSlaPatterns(slaDefinitionId);
  const dismiss = useDismissPattern();

  if (!hasPatternCap) return null;

  const patterns = (data?.data ?? []).map(adaptPattern);
  if (patterns.length === 0) return null;

  return (
    <Cap cap="sup.tela5.sla" variant={variant}>
      <div className="sla-patterns">
        {dismiss.isError && (
          <div className="banner banner--danger" role="alert">
            <div className="banner__body">
              <span className="banner__title">Falha ao dispensar o padrão.</span>
            </div>
          </div>
        )}
        {patterns.map((p) => (
          <div key={p.id} className="banner banner--warn">
            <span className="banner__icon" aria-hidden="true">
              ⚠
            </span>
            <div className="banner__body">
              <span className="banner__title">Padrão detectado · {p.title}</span>
              <span className="banner__sub">{p.subtitle}</span>
            </div>
            <button
              type="button"
              className="btn-ghost-mini"
              disabled={dismiss.isPending}
              onClick={() => {
                dismiss.mutate(p.id);
              }}
            >
              Dispensar
            </button>
          </div>
        ))}
      </div>
    </Cap>
  );
}
